__turbopack_context__.v({
  "images-box": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box",
  "images-box-body": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box-body",
  "images-box-body-lock-layer": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box-body-lock-layer",
  "images-box-header": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box-header",
  "images-box-header-contents": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box-header-contents",
  "images-box-header-divider": "EmailSignatureImageBox-module-scss-module__Q5wZRG__images-box-header-divider",
});
